import axios from 'axios';

const areaInSquareFeet = (roomId, length, width, roolWidth) => {
  const baseUrl = window?.__EXPERIENCE_PROPS__?.expConfiguration?.['flooring-base-url'];
  const path = 'api/calculations/roomArea';
  const params = `roomId=${roomId}&length=${length}&width=${width}&rollWidth=${roolWidth}`;
  const url = `${baseUrl}/${path}?${params}`;

  return axios.get(url)
    .then((response) => response.data)
    .catch((error) => { throw new Error(`API ERROR in ${path} ===>`, error); });
};

export default areaInSquareFeet;
